/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShareSlugRouteImport } from './routes/share.$slug'
import { Route as DevModelSwitcherPreviewRouteImport } from './routes/dev.model-switcher-preview'
import { Route as AuthenticatedWorkflowsRouteImport } from './routes/_authenticated/workflows'
import { Route as AuthenticatedTasksRouteImport } from './routes/_authenticated/tasks'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedStudioRouteImport } from './routes/_authenticated/studio'
import { Route as AuthenticatedNotebookRouteImport } from './routes/_authenticated/notebook'
import { Route as AuthenticatedIntegrationsRouteImport } from './routes/_authenticated/integrations'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated/inbox'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedChatHistoryRouteImport } from './routes/_authenticated/chat-history'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedWorkflowsIndexRouteImport } from './routes/_authenticated/workflows/index'
import { Route as AuthenticatedStudioIndexRouteImport } from './routes/_authenticated/studio/index'
import { Route as AuthenticatedChatIndexRouteImport } from './routes/_authenticated/chat/index'
import { Route as AuthenticatedWorkflowsSlugRouteImport } from './routes/_authenticated/workflows/$slug'
import { Route as AuthenticatedTasksTaskIdRouteImport } from './routes/_authenticated/tasks_.$taskId'
import { Route as AuthenticatedStudioAppDirRouteImport } from './routes/_authenticated/studio/$appDir'
import { Route as AuthenticatedChatThreadIdRouteImport } from './routes/_authenticated/chat/$threadId'
import { Route as AuthenticatedWorkflowsNewThreadIdRouteImport } from './routes/_authenticated/workflows/new.$threadId'
import { Route as AuthenticatedStudioNewThreadIdRouteImport } from './routes/_authenticated/studio/new.$threadId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareSlugRoute = ShareSlugRouteImport.update({
  id: '/share/$slug',
  path: '/share/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DevModelSwitcherPreviewRoute = DevModelSwitcherPreviewRouteImport.update({
  id: '/dev/model-switcher-preview',
  path: '/dev/model-switcher-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkflowsRoute = AuthenticatedWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksRoute = AuthenticatedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStudioRoute = AuthenticatedStudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotebookRoute = AuthenticatedNotebookRouteImport.update({
  id: '/notebook',
  path: '/notebook',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedIntegrationsRoute =
  AuthenticatedIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatHistoryRoute =
  AuthenticatedChatHistoryRouteImport.update({
    id: '/chat-history',
    path: '/chat-history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWorkflowsIndexRoute =
  AuthenticatedWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkflowsRoute,
  } as any)
const AuthenticatedStudioIndexRoute =
  AuthenticatedStudioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedStudioRoute,
  } as any)
const AuthenticatedChatIndexRoute = AuthenticatedChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedChatRoute,
} as any)
const AuthenticatedWorkflowsSlugRoute =
  AuthenticatedWorkflowsSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => AuthenticatedWorkflowsRoute,
  } as any)
const AuthenticatedTasksTaskIdRoute =
  AuthenticatedTasksTaskIdRouteImport.update({
    id: '/tasks_/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStudioAppDirRoute =
  AuthenticatedStudioAppDirRouteImport.update({
    id: '/$appDir',
    path: '/$appDir',
    getParentRoute: () => AuthenticatedStudioRoute,
  } as any)
const AuthenticatedChatThreadIdRoute =
  AuthenticatedChatThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => AuthenticatedChatRoute,
  } as any)
const AuthenticatedWorkflowsNewThreadIdRoute =
  AuthenticatedWorkflowsNewThreadIdRouteImport.update({
    id: '/new/$threadId',
    path: '/new/$threadId',
    getParentRoute: () => AuthenticatedWorkflowsRoute,
  } as any)
const AuthenticatedStudioNewThreadIdRoute =
  AuthenticatedStudioNewThreadIdRouteImport.update({
    id: '/new/$threadId',
    path: '/new/$threadId',
    getParentRoute: () => AuthenticatedStudioRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/chat': typeof AuthenticatedChatRouteWithChildren
  '/chat-history': typeof AuthenticatedChatHistoryRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/integrations': typeof AuthenticatedIntegrationsRoute
  '/notebook': typeof AuthenticatedNotebookRoute
  '/studio': typeof AuthenticatedStudioRouteWithChildren
  '/support': typeof AuthenticatedSupportRoute
  '/tasks': typeof AuthenticatedTasksRoute
  '/workflows': typeof AuthenticatedWorkflowsRouteWithChildren
  '/dev/model-switcher-preview': typeof DevModelSwitcherPreviewRoute
  '/share/$slug': typeof ShareSlugRoute
  '/chat/$threadId': typeof AuthenticatedChatThreadIdRoute
  '/studio/$appDir': typeof AuthenticatedStudioAppDirRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/workflows/$slug': typeof AuthenticatedWorkflowsSlugRoute
  '/chat/': typeof AuthenticatedChatIndexRoute
  '/studio/': typeof AuthenticatedStudioIndexRoute
  '/workflows/': typeof AuthenticatedWorkflowsIndexRoute
  '/studio/new/$threadId': typeof AuthenticatedStudioNewThreadIdRoute
  '/workflows/new/$threadId': typeof AuthenticatedWorkflowsNewThreadIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/chat-history': typeof AuthenticatedChatHistoryRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/integrations': typeof AuthenticatedIntegrationsRoute
  '/notebook': typeof AuthenticatedNotebookRoute
  '/support': typeof AuthenticatedSupportRoute
  '/tasks': typeof AuthenticatedTasksRoute
  '/dev/model-switcher-preview': typeof DevModelSwitcherPreviewRoute
  '/share/$slug': typeof ShareSlugRoute
  '/chat/$threadId': typeof AuthenticatedChatThreadIdRoute
  '/studio/$appDir': typeof AuthenticatedStudioAppDirRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/workflows/$slug': typeof AuthenticatedWorkflowsSlugRoute
  '/chat': typeof AuthenticatedChatIndexRoute
  '/studio': typeof AuthenticatedStudioIndexRoute
  '/workflows': typeof AuthenticatedWorkflowsIndexRoute
  '/studio/new/$threadId': typeof AuthenticatedStudioNewThreadIdRoute
  '/workflows/new/$threadId': typeof AuthenticatedWorkflowsNewThreadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_authenticated/chat': typeof AuthenticatedChatRouteWithChildren
  '/_authenticated/chat-history': typeof AuthenticatedChatHistoryRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/inbox': typeof AuthenticatedInboxRoute
  '/_authenticated/integrations': typeof AuthenticatedIntegrationsRoute
  '/_authenticated/notebook': typeof AuthenticatedNotebookRoute
  '/_authenticated/studio': typeof AuthenticatedStudioRouteWithChildren
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_authenticated/tasks': typeof AuthenticatedTasksRoute
  '/_authenticated/workflows': typeof AuthenticatedWorkflowsRouteWithChildren
  '/dev/model-switcher-preview': typeof DevModelSwitcherPreviewRoute
  '/share/$slug': typeof ShareSlugRoute
  '/_authenticated/chat/$threadId': typeof AuthenticatedChatThreadIdRoute
  '/_authenticated/studio/$appDir': typeof AuthenticatedStudioAppDirRoute
  '/_authenticated/tasks_/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/_authenticated/workflows/$slug': typeof AuthenticatedWorkflowsSlugRoute
  '/_authenticated/chat/': typeof AuthenticatedChatIndexRoute
  '/_authenticated/studio/': typeof AuthenticatedStudioIndexRoute
  '/_authenticated/workflows/': typeof AuthenticatedWorkflowsIndexRoute
  '/_authenticated/studio/new/$threadId': typeof AuthenticatedStudioNewThreadIdRoute
  '/_authenticated/workflows/new/$threadId': typeof AuthenticatedWorkflowsNewThreadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/chat'
    | '/chat-history'
    | '/dashboard'
    | '/inbox'
    | '/integrations'
    | '/notebook'
    | '/studio'
    | '/support'
    | '/tasks'
    | '/workflows'
    | '/dev/model-switcher-preview'
    | '/share/$slug'
    | '/chat/$threadId'
    | '/studio/$appDir'
    | '/tasks/$taskId'
    | '/workflows/$slug'
    | '/chat/'
    | '/studio/'
    | '/workflows/'
    | '/studio/new/$threadId'
    | '/workflows/new/$threadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/chat-history'
    | '/dashboard'
    | '/inbox'
    | '/integrations'
    | '/notebook'
    | '/support'
    | '/tasks'
    | '/dev/model-switcher-preview'
    | '/share/$slug'
    | '/chat/$threadId'
    | '/studio/$appDir'
    | '/tasks/$taskId'
    | '/workflows/$slug'
    | '/chat'
    | '/studio'
    | '/workflows'
    | '/studio/new/$threadId'
    | '/workflows/new/$threadId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/_authenticated/chat'
    | '/_authenticated/chat-history'
    | '/_authenticated/dashboard'
    | '/_authenticated/inbox'
    | '/_authenticated/integrations'
    | '/_authenticated/notebook'
    | '/_authenticated/studio'
    | '/_authenticated/support'
    | '/_authenticated/tasks'
    | '/_authenticated/workflows'
    | '/dev/model-switcher-preview'
    | '/share/$slug'
    | '/_authenticated/chat/$threadId'
    | '/_authenticated/studio/$appDir'
    | '/_authenticated/tasks_/$taskId'
    | '/_authenticated/workflows/$slug'
    | '/_authenticated/chat/'
    | '/_authenticated/studio/'
    | '/_authenticated/workflows/'
    | '/_authenticated/studio/new/$threadId'
    | '/_authenticated/workflows/new/$threadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  DevModelSwitcherPreviewRoute: typeof DevModelSwitcherPreviewRoute
  ShareSlugRoute: typeof ShareSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$slug': {
      id: '/share/$slug'
      path: '/share/$slug'
      fullPath: '/share/$slug'
      preLoaderRoute: typeof ShareSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/model-switcher-preview': {
      id: '/dev/model-switcher-preview'
      path: '/dev/model-switcher-preview'
      fullPath: '/dev/model-switcher-preview'
      preLoaderRoute: typeof DevModelSwitcherPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workflows': {
      id: '/_authenticated/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AuthenticatedWorkflowsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks': {
      id: '/_authenticated/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/studio': {
      id: '/_authenticated/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof AuthenticatedStudioRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notebook': {
      id: '/_authenticated/notebook'
      path: '/notebook'
      fullPath: '/notebook'
      preLoaderRoute: typeof AuthenticatedNotebookRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations': {
      id: '/_authenticated/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inbox': {
      id: '/_authenticated/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthenticatedInboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat-history': {
      id: '/_authenticated/chat-history'
      path: '/chat-history'
      fullPath: '/chat-history'
      preLoaderRoute: typeof AuthenticatedChatHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat': {
      id: '/_authenticated/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workflows/': {
      id: '/_authenticated/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AuthenticatedWorkflowsIndexRouteImport
      parentRoute: typeof AuthenticatedWorkflowsRoute
    }
    '/_authenticated/studio/': {
      id: '/_authenticated/studio/'
      path: '/'
      fullPath: '/studio/'
      preLoaderRoute: typeof AuthenticatedStudioIndexRouteImport
      parentRoute: typeof AuthenticatedStudioRoute
    }
    '/_authenticated/chat/': {
      id: '/_authenticated/chat/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof AuthenticatedChatIndexRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    '/_authenticated/workflows/$slug': {
      id: '/_authenticated/workflows/$slug'
      path: '/$slug'
      fullPath: '/workflows/$slug'
      preLoaderRoute: typeof AuthenticatedWorkflowsSlugRouteImport
      parentRoute: typeof AuthenticatedWorkflowsRoute
    }
    '/_authenticated/tasks_/$taskId': {
      id: '/_authenticated/tasks_/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/studio/$appDir': {
      id: '/_authenticated/studio/$appDir'
      path: '/$appDir'
      fullPath: '/studio/$appDir'
      preLoaderRoute: typeof AuthenticatedStudioAppDirRouteImport
      parentRoute: typeof AuthenticatedStudioRoute
    }
    '/_authenticated/chat/$threadId': {
      id: '/_authenticated/chat/$threadId'
      path: '/$threadId'
      fullPath: '/chat/$threadId'
      preLoaderRoute: typeof AuthenticatedChatThreadIdRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    '/_authenticated/workflows/new/$threadId': {
      id: '/_authenticated/workflows/new/$threadId'
      path: '/new/$threadId'
      fullPath: '/workflows/new/$threadId'
      preLoaderRoute: typeof AuthenticatedWorkflowsNewThreadIdRouteImport
      parentRoute: typeof AuthenticatedWorkflowsRoute
    }
    '/_authenticated/studio/new/$threadId': {
      id: '/_authenticated/studio/new/$threadId'
      path: '/new/$threadId'
      fullPath: '/studio/new/$threadId'
      preLoaderRoute: typeof AuthenticatedStudioNewThreadIdRouteImport
      parentRoute: typeof AuthenticatedStudioRoute
    }
  }
}

interface AuthenticatedChatRouteChildren {
  AuthenticatedChatThreadIdRoute: typeof AuthenticatedChatThreadIdRoute
  AuthenticatedChatIndexRoute: typeof AuthenticatedChatIndexRoute
}

const AuthenticatedChatRouteChildren: AuthenticatedChatRouteChildren = {
  AuthenticatedChatThreadIdRoute: AuthenticatedChatThreadIdRoute,
  AuthenticatedChatIndexRoute: AuthenticatedChatIndexRoute,
}

const AuthenticatedChatRouteWithChildren =
  AuthenticatedChatRoute._addFileChildren(AuthenticatedChatRouteChildren)

interface AuthenticatedStudioRouteChildren {
  AuthenticatedStudioAppDirRoute: typeof AuthenticatedStudioAppDirRoute
  AuthenticatedStudioIndexRoute: typeof AuthenticatedStudioIndexRoute
  AuthenticatedStudioNewThreadIdRoute: typeof AuthenticatedStudioNewThreadIdRoute
}

const AuthenticatedStudioRouteChildren: AuthenticatedStudioRouteChildren = {
  AuthenticatedStudioAppDirRoute: AuthenticatedStudioAppDirRoute,
  AuthenticatedStudioIndexRoute: AuthenticatedStudioIndexRoute,
  AuthenticatedStudioNewThreadIdRoute: AuthenticatedStudioNewThreadIdRoute,
}

const AuthenticatedStudioRouteWithChildren =
  AuthenticatedStudioRoute._addFileChildren(AuthenticatedStudioRouteChildren)

interface AuthenticatedWorkflowsRouteChildren {
  AuthenticatedWorkflowsSlugRoute: typeof AuthenticatedWorkflowsSlugRoute
  AuthenticatedWorkflowsIndexRoute: typeof AuthenticatedWorkflowsIndexRoute
  AuthenticatedWorkflowsNewThreadIdRoute: typeof AuthenticatedWorkflowsNewThreadIdRoute
}

const AuthenticatedWorkflowsRouteChildren: AuthenticatedWorkflowsRouteChildren =
  {
    AuthenticatedWorkflowsSlugRoute: AuthenticatedWorkflowsSlugRoute,
    AuthenticatedWorkflowsIndexRoute: AuthenticatedWorkflowsIndexRoute,
    AuthenticatedWorkflowsNewThreadIdRoute:
      AuthenticatedWorkflowsNewThreadIdRoute,
  }

const AuthenticatedWorkflowsRouteWithChildren =
  AuthenticatedWorkflowsRoute._addFileChildren(
    AuthenticatedWorkflowsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedChatRoute: typeof AuthenticatedChatRouteWithChildren
  AuthenticatedChatHistoryRoute: typeof AuthenticatedChatHistoryRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedInboxRoute: typeof AuthenticatedInboxRoute
  AuthenticatedIntegrationsRoute: typeof AuthenticatedIntegrationsRoute
  AuthenticatedNotebookRoute: typeof AuthenticatedNotebookRoute
  AuthenticatedStudioRoute: typeof AuthenticatedStudioRouteWithChildren
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedTasksRoute: typeof AuthenticatedTasksRoute
  AuthenticatedWorkflowsRoute: typeof AuthenticatedWorkflowsRouteWithChildren
  AuthenticatedTasksTaskIdRoute: typeof AuthenticatedTasksTaskIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedChatRoute: AuthenticatedChatRouteWithChildren,
  AuthenticatedChatHistoryRoute: AuthenticatedChatHistoryRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedInboxRoute: AuthenticatedInboxRoute,
  AuthenticatedIntegrationsRoute: AuthenticatedIntegrationsRoute,
  AuthenticatedNotebookRoute: AuthenticatedNotebookRoute,
  AuthenticatedStudioRoute: AuthenticatedStudioRouteWithChildren,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedTasksRoute: AuthenticatedTasksRoute,
  AuthenticatedWorkflowsRoute: AuthenticatedWorkflowsRouteWithChildren,
  AuthenticatedTasksTaskIdRoute: AuthenticatedTasksTaskIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  DevModelSwitcherPreviewRoute: DevModelSwitcherPreviewRoute,
  ShareSlugRoute: ShareSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
